import { Box, Typography } from '@mui/material';

export default function AppFooter() {
    return (
        <Box
            component="footer"
            sx={{
                flexShrink: 0,
                py: 1.5,
                mt: 'auto',
                borderTop: 1,
                borderColor: 'divider',
                textAlign: 'center',
            }}
        >
            <Typography variant="caption" color="text.secondary">
                © Precia Molen Ireland
            </Typography>
        </Box>
    );
}
